/**
 * readyState
 * 0 正在连接
 * 1 已经连接成功，可以通讯
 * 2 连接正在关闭
 * 3 连接已经关闭或者没有连接成功
*/
export default class {
  constructor (url, opts = {}) {
    this.events = {}

    this.reconnectionAttempts = opts.reconnectionAttempts || 5
    this.reconectionDelay = opts.reconectionDelay

    this.reconectionTimeoutId = 0
    this.reconectionCount = 0

    this.opts = opts
    this.token = opts.token

    this.heartInterval = 1000 * 60 * 3 // 3分钟
    this.heartTimer = null
    this.init(url, opts)
  }

  /**
   * 初始化
   * 连接websocket
   * 绑定系统事件
  */
  init (url, opts) {
    this.client = new WebSocket(url)

    /**
     * 成功连接websocket后
     * 使用的
    */
    this.client.onopen = () => {
      this.login(
        opts.userId,
        opts.sysCode,
        opts.token
      )
      console.log('向后台发送登陆 Auth')
      this.heartStart()
    }
    this.client.onerror = (error) => {
      console.log('出错了', error)
    }
    this.client.onclose = () => {
      console.log('关闭了')
      this.heartTimer = window.clearInterval(this.heartTimer)
    }
    this.client.onmessage = (event) => {
      // console.log('收到服务器的消息', event)

      const resp = JSON.parse(event.data)
      // console.log('收到消息内容是', resp)
      // console.log(`收到消息类型为${resp.operation}`)

      /**
       * 触发已绑定的事件
      */
      if (
        resp.operation &&
        typeof this.events[resp.operation] === 'function'
      ) {
        console.log(`触发事件 ${resp.operation}`)
        this.events[resp.operation](resp.data)
      }
    }

    return this.client
  }

  /**
   * 发送事件
   * @param {string} operation 事件类型
   * @param {object} data 事件参数
  */
  send (operation, data) {
    const readyState = this.client.readyState
    console.log('连接状态：', readyState)

    return new Promise((resolve, reject) => {
      if (this.client.readyState === 1) {
        const message = {
          operation,
          data,
          token: this.token
        }

        console.log(`发送消息${operation}`, JSON.stringify(message))

        this.client.send(JSON.stringify(message))

        resolve()
      } else {
        reject(new Error(`当前连接状态为：${readyState}, 无法发送消息`))
      }
    })
  }

  /**
   * 绑定自定义事件
   * @param {string} operation 事件类型
   * @param {function} func 回调函数
  */
  on (operation, func) {
    if (typeof func !== 'function') {
      console.warn('第二参数为回调函数，必传')
    }

    this.events[operation] = func
    console.log(`成功绑定${operation}事件, 已绑定的事件为${Object.keys(this.events)}`)
  }

  /**
   * 登陆
  */
  login (userId, sysCode, token) {
    const operation = 'Auth'

    const data = {
      userId,
      sysCode,
      httpToken: token,
    }
    this.send(operation, data)
  }

  /**
   * 下线
  */
  logout () {
    const operation = 'Offline'

    const data = {
      token: this.token
    }

    this.send(operation, data)
    this.client.close()
  }

  heartStart () {
    this.heartTimer = window.setInterval(() => {
      this.heartBeat()
    }, this.heartInterval)

    this.heartBeat()

    this.on('HeartBeat', () => {
      console.log('接送到心跳回应')
    })
  }

  heartBeat () {
    const operation = 'HeartBeat'
    const data = {
      userId: this.opts.userId,
      sysCode: this.opts.sysCode
    }
    this.send(operation, data)
  }
}
